var map = {
	"./10.svg": "3069",
	"./11.svg": "28e6",
	"./12.svg": "2a62",
	"./13.svg": "c9f4",
	"./14.svg": "9133",
	"./15.svg": "920e",
	"./16.svg": "ceef",
	"./17.svg": "b1f7",
	"./18.svg": "d5a0",
	"./19.svg": "d51b",
	"./2.svg": "26db",
	"./20.svg": "9c98",
	"./21.svg": "1075",
	"./3.svg": "d817",
	"./4.svg": "2572",
	"./5.svg": "731e",
	"./7.svg": "e04b",
	"./8.svg": "a1d7",
	"./9.svg": "f4c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2739";